import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  tickets: [],
  ticketStates: [],
  ticketStatuses: [],
  ticketTypes: [],
  ticketChannels: [],
  channels: [],
  labels: [],
  labelTypes: [],
  user: null,

  // Ticket Specific Variables
  ticket: null,
  readers: [],
  messages: [],
  messageAmazonChannel: null,
  messageEbayChannel: null,
  messageEmailChannel: null,
  messageFormChannel: null,
  messageMagentoChannel: null,
  messageEmail: null,
  messageTypes: [],
  notes: [],
  replies: [],
  replyTypes: [],
  snippetCategories: [],
  snippets: [],
  snippetTypes: [],
  snoozes: [],
  tasks: [],
  templates: [],
  templateTypes: [],

  // Ticket View Specific Values
  defaultSearchFilters: {
    isActive: false,
    channel: [],
    status: [],

    agent: [],
    team: [],

    product: null,
    order: null,

    name: null,
    email: null,
    shipping: null,

    type: [],

    created: null,
    latest: null,

    priority: false,
    followUp: false,
    snoozed: false,
    deleted: false,
    spam: false,
  },
  searchFilters: {
    isActive: false,
    channel: [],
    status: [],

    agent: [],
    team: [],

    product: null,
    order: null,

    name: null,
    email: null,
    shipping: null,

    type: [],

    created: null,
    latest: null,

    priority: false,
    followUp: false,
    snoozed: false,
    deleted: false,
    spam: false,
  },
  sorting: {
    page: 1,
    sortBy: 'id',
    sortOrder: 'desc',
    limit: 10,
  },
  ticketsPages: [],
  defaultColumns: [
    {id: 'assigned', name: 'Assigned', sortable: false, icon: 'user', sortOrder: 1, visibility: true,},
    {id: 'channel', name: 'Channel', sortable: true, icon: 'plug', sortOrder: 2, visibility: true,},
    {id: 'type', name: 'Ticket Type', sortable: true, icon: '', sortOrder: 3, visibility: true,},
    {id: 'customerName', name: 'Customer', sortable: true, icon: '', sortOrder: 4, visibility: true,},
    {id: 'subject', name: 'Subject', sortable: true, icon: '', sortOrder: 5, visibility: true,},
    {id: 'timeLeft', name: 'Time Left', sortable: true, icon: '', sortOrder: 6, visibility: true,},
    {id: 'updated', name: 'Updated', sortable: false, icon: '', sortOrder: 7, visibility: true,},
    {id: 'created', name: 'Created', sortable: true, icon: '', sortOrder: 8, visibility: false,},
    {id: 'status', name: 'Status', sortable: true, icon: '', sortOrder: 9, visibility: false,},
    {id: 'latestMessage', name: 'Latest Message', sortable: false, icon: '', sortOrder: 10, visibility: false,},
    {id: 'latestMessageDate', name: 'Message Date', sortable: true, icon: '', sortOrder: 11, visibility: false,},
    {id: 'latestReplyDate', name: 'Reply Date', sortable: false, icon: '', sortOrder: 12, visibility: false,},
    {id: 'customerEmail', name: 'Email', sortable: true, icon: '', sortOrder: 13, visibility: false,},
    {id: 'customerTelephone', name: 'Telephone', sortable: true, icon: '', sortOrder: 14, visibility: false,},
    {id: 'urgent', name: 'Priority', sortable: true, icon: '', sortOrder: 15, visibility: false,},
    {id: 'totalMessages', name: 'Total Messages', sortable: true, icon: '', sortOrder: 16, visibility: false,},
    {id: 'totalReplies', name: 'Total Replies', sortable: true, icon: '', sortOrder: 17, visibility: false,},
    {id: 'id', name: 'ID', sortable: true, icon: '', sortOrder: 18, visibility: false,},
    {id: 'age', name: 'Age', sortable: true, icon: '', sortOrder: 19, visibility: false,},
  ],
  columns: [
    {id: 'assigned', name: 'Assigned', sortable: false, icon: 'user', sortOrder: 1, visibility: true,},
    {id: 'channel', name: 'Channel', sortable: true, icon: 'plug', sortOrder: 2, visibility: true,},
    {id: 'type', name: 'Ticket Type', sortable: true, icon: '', sortOrder: 3, visibility: true,},
    {id: 'customerName', name: 'Customer', sortable: true, icon: '', sortOrder: 4, visibility: true,},
    {id: 'subject', name: 'Subject', sortable: true, icon: '', sortOrder: 5, visibility: true,},
    {id: 'timeLeft', name: 'Time Left', sortable: true, icon: '', sortOrder: 6, visibility: true,},
    {id: 'updated', name: 'Updated', sortable: false, icon: '', sortOrder: 7, visibility: true,},
    {id: 'created', name: 'Created', sortable: true, icon: '', sortOrder: 8, visibility: false,},
    {id: 'status', name: 'Status', sortable: true, icon: '', sortOrder: 9, visibility: false,},
    {id: 'latestMessage', name: 'Latest Message', sortable: false, icon: '', sortOrder: 10, visibility: false,},
    {id: 'latestMessageDate', name: 'Message Date', sortable: true, icon: '', sortOrder: 11, visibility: false,},
    {id: 'latestReplyDate', name: 'Reply Date', sortable: false, icon: '', sortOrder: 12, visibility: false,},
    {id: 'customerEmail', name: 'Email', sortable: true, icon: '', sortOrder: 13, visibility: false,},
    {id: 'customerTelephone', name: 'Telephone', sortable: true, icon: '', sortOrder: 14, visibility: false,},
    {id: 'urgent', name: 'Priority', sortable: true, icon: '', sortOrder: 15, visibility: false,},
    {id: 'totalMessages', name: 'Total Messages', sortable: true, icon: '', sortOrder: 16, visibility: false,},
    {id: 'totalReplies', name: 'Total Replies', sortable: true, icon: '', sortOrder: 17, visibility: false,},
    {id: 'id', name: 'ID', sortable: true, icon: '', sortOrder: 18, visibility: false,},
    {id: 'age', name: 'Age', sortable: true, icon: '', sortOrder: 19, visibility: false,},
  ],
  views: [
    {id: 'open', name: 'Open Tickets', system: true},
    {id: 'assigned', name: 'Assigned Tickets', system: true},
    {id: 'team', name: 'Team Tickets', system: true},
    {id: 'priority', name: 'Priority Tickets', system: true},
    {id: 'followup', name: 'Follow Up Tickets', system: true},
    {id: 'favourites', name: 'Favourite Tickets', system: true},
    {id: 'waiting', name: 'Waiting Tickets', system: true},
    {id: 'resolved', name: 'Resolved Tickets', system: true},
    {id: 'snoozed', name: 'Snoozed Tickets', system: true},
    {id: 'spam', name: 'Spam Tickets', system: true},
    {id: 'waiting', name: 'Waiting Tickets', system: true},
    {id: 'deleted', name: 'Deleted Tickets', system: true},
    {id: 'all', name: 'All Tickets', system: true},
  ],

  sampleTickets: [
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 7,
      customers_id: 1,
      message_types_id: 1,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'Request for Order Change',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'John',
        lastName: 'Smith',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-28 09:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 6,
      customers_id: 1,
      message_types_id: 1,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'Shipping Update Needed',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'George',
        lastName: 'William',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-30 13:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-22 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 5,
      customers_id: 1,
      message_types_id: 1,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'Could you please requote us on the bubble wrap',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'Nina',
        lastName: 'Alexander',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-28 09:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 7,
      customers_id: 1,
      message_types_id: 4,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'How long does delivery to UK take?',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'Laurie',
        lastName: 'Hocking',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-28 09:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 8,
      customers_id: 1,
      message_types_id: 1,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'Wrong items were delivered. Arrange a return..',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'Michael',
        lastName: 'Ilyas',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-28 09:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
    {
      id: '4575',
      ticket_states_id: 2,
      tickets_status_id: 1,
      company_channels_id: 1,
      channel: 4,
      ticket_types_id: 9,
      customers_id: 1,
      message_types_id: 1,
      orders_id: 1,
      order_inr_id: null,
      order_returns_id: null,
      order_cases_id: null,
      order_cancellation_id: null,
      subject: 'Items are damaged. Need refund.',
      urgent: 0,
      snoozed: 0,
      followUp: 0,
      replyVirtualEmail: 'dUdY6d@seganta.com',
      counted: 1,
      deleted: 0,
      spam: 0,
      customer: {
        id: '1',
        title: 'Mr',
        firstName: 'Samantha',
        lastName: 'Joseph',
        name: 'Mr John Smith',
        email: 'john@seganta.com',
        telephone: '07951380588',
      },
      labels: [
        {
          id: '1',
          label_types_id: '1',
          name: 'Important',
          color: 'orange',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '2',
        },
        {
          id: '2',
          label_types_id: '1',
          name: 'VIP',
          color: 'red',
          icon: 'circle',
          sortOrder: '1',
          public: '1',
          messages: '4',
        },
      ],
      readers: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   users_id: '',
        //   created_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        //   updated_at: {
        //     "date": "2018-01-02 11:12:47.000000",
        //     "timezone_type": 3,
        //     "timezone": "UTC"
        //   },
        // },
      ],
      teams: [
        {
          id: '1',
          managerID: '141',
          ownerID: '141',
          name: 'Helpdesk Team',
        },
      ],
      urgency: [
        {
          id: '1',
          tickets_id: '4575',
          urgencyScore: '35',
          waitingMessages: '1',
          scheduleReplyDate: '2018-04-28 09:00:00',
          ActualReplyDate: null,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      users: [
        {
          id: '141',
          name: 'Ali Malik',
          email: 'malik@seganta.com',
          favouriteTickets: {

          },
          watchedTickets: {

          },
          snippets: {

          },
        },
      ],
      latestMessage: {
        id: 2,
        tickets_id: 4575,
        message_types_id: 1,
        subject: 'Waiting for my order update',
        HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
        plainBody: 'Hello there, Can you please kindly send...',
        received_at: '2018-04-25 11:35:00',
        attachments: {

        },
      },
      totalMessages: 2,
      latestReplyDate: '2018-04-24 14:06:25',
      totalReplies: 1,
      incidentDate: '2018-04-21 11:12:47',
      created_at: {
        "date": "2018-04-21 11:12:47.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      updated_at: {
        "date": "2018-04-24 14:06:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      // TODO: Ticket Specific Attributes - Readjust Code Later
      notes: [
        {
          id: 1,
          tickets_id: 4575,
          users_id: 141,
          notes: 'There is a probem with the courier. <br/><br/> Someone needs to contact Yodel so we can update the customer.',
          created_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 14:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
        {
          id: 2,
          tickets_id: 4575,
          users_id: 141,
          notes: 'Yodel has responded with the tracking number. <br/><br/> Please give the customer the following number: J5055899874566.',
          created_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-25 16:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      snoozes: [
        {
          id: 1,
          tickets_id: 4575,
          ownerID: 141,
          snoozeUntil: '2018-04-27 09:30:00',
          status: 1,
          created_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-01-02 11:12:47.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
      tasks: [
        // {
        //   id: '',
        //   tickets_id: '',
        //   tasks_id: '',
        // },
      ],
      watchers: [
        // {
        //   id: '',
        //   name: '',
        //   email: '',
        //   favouriteTickets: {
        //
        //   },
        //   watchedTickets: {
        //
        //   },
        //   snippets: {
        //
        //   },
        // },
      ],
      attachments: [
        // {
        //   id: '',
        //   name: '',
        // },
      ],
      messages: [
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Dear Sales Team, <br/><br/> I placed an order few days ago? <br/><br/> Could you please update me with the shipping progress. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-21 11:12:47',
          attachments: {

          },
        },
        {
          id: 1,
          tickets_id: 4575,
          message_types_id: 1,
          subject: 'Waiting for my order update',
          HTMLbody: 'Hello there, <br/><br/> Can you please kindly send us the tracking number at least? <br/><br/> I will look forward to your quick reply. <br/><br/> Best Regards, <br/> John',
          plainBody: 'Hello there, Can you please kindly send...',
          received_at: '2018-04-25 11:35:00',
          attachments: {

          },
        },
      ],

      replies: [
        {
          id: 1,
          tickets_id: 4575,
          replyType: 2,
          ownerID: 141,
          scheduleDate: "2018-04-23 15:35:00",
          sentDateTime: "2018-04-23 15:35:00",
          replyDetails: {
            'id': 1,
            'replies_id': 1,
            'replyCCEmailArray': [],
            'replyBCCEmailArray': [],
            'replyFromName': 'support@seganta.com',
            'body': 'Dear John, <br/><br/> My sincere apologies for the delay. <br/><br/> Your order has been dispatched already and you should receive it soon.<br/><br/> Best Regards,<br/> Malik',
            created_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
            updated_at: {
              "date": "2018-04-23 15:35:00.000000",
              "timezone_type": 3,
              "timezone": "UTC"
            },
          },
          status: 1,
          errorDetails: null,
          created_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
          updated_at: {
            "date": "2018-04-23 15:35:00.000000",
            "timezone_type": 3,
            "timezone": "UTC"
          },
        },
      ],
    },
  ]
};

const getters = {

  getSampleTickets(state) {
    return state.sampleTickets
  },

  getDefaultSearchFilters (state) {
    return state.defaultSearchFilters
  },

  getSearchFilters (state) {
    return state.searchFilters
  },

  getSorting (state) {
    return state.sorting
  },

  getColumns (state) {
    return state.columns
  },

  getDefaultColumns (state) {
    return state.defaultColumns
  },

  getViews (state) {
    return state.views
  },

  getTickets (state) {
    return state.tickets
  },

  getTicketsPages (state) {
    return state.ticketsPages
  },

  getTicketStates (state) {
    return state.ticketStates
  },

  getTicketStatuses (state) {
    return state.ticketStatuses
  },

  getTicketTypes (state) {
    return state.ticketTypes
  },

  getTicketChannels (state) {
    return state.ticketChannels
  },

  getEmailChannels (state) {
    return state.ticketChannels.filter(function (el) {
      return el.channelGroup === 1;
    })
  },

  getChannels (state) {
    return state.channels
  },

  getLabels (state) {
    return state.labels
  },

  getLabelTypes (state) {
    return state.labelTypes
  },

  getUser (state) {
    return state.user
  },

  getTicket (state) {
    return state.ticket
  },

  getReaders (state) {
    return state.readers
  },

  getMessages (state) {
    return state.messages
  },

  getMessageAmazonChannel (state) {
    return state.messageAmazonChannel
  },

  getMessageEbayChannel (state) {
    return state.messageEbayChannel
  },

  getMessageEmailChannel (state) {
    return state.messageEmailChannel
  },

  getMessageFormChannel (state) {
    return state.messageFormChannel
  },

  getMessageMagentoChannel (state) {
    return state.messageMagentoChannel
  },

  getMessageEmail (state) {
    return state.messageEmail
  },

  getMessageTypes (state) {
    return state.messageTypes
  },

  getNotes (state) {
    return state.notes
  },

  getReplies (state) {
    return state.replies
  },

  getReplyTypes (state) {
    return state.replyTypes
  },

  getSnippetCategories (state) {
    return state.snippetCategories
  },

  getSnippets (state) {
    return state.snippets
  },

  getSnippetTypes (state) {
    return state.snippetTypes
  },

  getSnoozes (state) {
    return state.snoozes
  },

  getTasks (state) {
    return state.tasks
  },

  getTemplates (state) {
    return state.templates
  },

  getTemplateTypes (state) {
    return state.templateTypes
  },

};

const mutations = {
  resetSearchFilters (state, payload){
    state.searchFilters = state.defaultSearchFilters
    console.log('Search Filter Reset')
  },

  setTickets (state, payload) {
    state.tickets = payload
  },

  setTicketsPages (state, payload) {
    state.ticketsPages = payload
  },

  setTicketStates (state, payload) {
    state.ticketStates = payload
  },

  setTicketStatuses (state, payload) {
    state.ticketStatuses = payload
  },

  setTicketTypes (state, payload) {
    state.ticketTypes = payload
  },

  setTicketChannels (state, payload) {
    state.ticketChannels = payload
  },

  setChannels (state, payload) {
    state.channels = payload
  },

  setLabels (state, payload) {
    state.labels = payload
  },

  setLabelTypes (state, payload) {
    state.labelTypes = payload
  },

  setUser (state, payload) {
    state.user = payload
  },

  setTicket (state, payload) {
    state.ticket = payload
  },

  setReaders (state, payload) {
    state.readers = payload
  },

  setMessages (state, payload) {
    state.messages = payload
  },

  setMessageAmazonChannel (state, payload) {
    state.messageAmazonChannel = payload
  },

  setMessageEbayChannel (state, payload) {
    state.messageEbayChannel = payload
  },

  setMessageEmailChannel (state, payload) {
    state.messageEmailChannel = payload
  },

  setMessageFormChannel (state, payload) {
    state.messageFormChannel = payload
  },

  setMessageMagentoChannel (state, payload) {
    state.messageMagentoChannel = payload
  },

  setMessageEmail (state, payload) {
    state.messageEmail = payload
  },

  setMessageTypes (state, payload) {
    state.messageTypes = payload
  },

  setNotes (state, payload) {
    state.notes = payload
  },

  setReplies (state, payload) {
    state.replies = payload
  },

  setReplyTypes (state, payload) {
    state.replyTypes = payload
  },

  setSnippetCategories (state, payload) {
    state.snippetCategories = payload
  },

  setSnippets (state, payload) {
    state.snippets = payload
  },

  setSnippetTypes (state, payload) {
    state.snippetTypes = payload
  },

  setSnoozes (state, payload) {
    state.snoozes = payload
  },

  setTasks (state, payload) {
    state.tasks = payload
  },

  setTemplates (state, payload) {
    state.templates = payload
  },

  setTemplateTypes (state, payload) {
    state.templateTypes = payload
  },

};

const actions = {

  fetchTickets ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticket', {
        params: {
          name: payload.filters.name,
          email: payload.filters.email,
          shipping: payload.filters.shipping,
          product: payload.filters.product,
          order: payload.filters.order,
          channel: payload.filters.channel,
          agent: payload.filters.agent,
          team: payload.filters.team,
          type: payload.filters.type,
          status: payload.filters.status,
          snoozed: payload.filters.snoozed,
          followUp: payload.filters.followUp,
          created: payload.filters.created,
          latest: payload.filters.latest,
          deleted: payload.filters.deleted,
          spam: payload.filters.spam,
          urgent: payload.filters.priority,
          limit: payload.sorting.limit,
          page: payload.sorting.page,
          sortBy: payload.sorting.sortBy,
          sortOrder: payload.sorting.sortOrder,
        }
        })
        .then(res => {
          commit('setTickets', res.data.data)
          commit('setTicketsPages', {meta: res.data.meta, links:res.data.links})
          console.log('fetchTickets - Tickets Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketsFromView ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticket', {
        params: {
          view: payload.view,
          limit: payload.sorting.limit,
          page: payload.sorting.page,
          sortBy: payload.sorting.sortBy,
          sortOrder: payload.sorting.sortOrder,
        }
      })
        .then(res => {
          commit('setTickets', res.data.data)
          commit('setTicketsPages', {meta: res.data.meta, links:res.data.links})
          console.log('fetchTicketsFromView - View Tickets Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketsCount ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticket', {
        params: {
          view: payload,
          count: '1',
        }
      })
        .then(res => {
          console.log('fetchTicketsCount - '+ payload +' View Tickets Fetched.');
          resolve(res.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketStates ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticketState')
        .then(res => {
          commit('setTicketStates', res.data.data)
          console.log('fetchTicketStates - Ticket States Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketStatuses ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticketStatus')
        .then(res => {
          commit('setTicketStatuses', res.data.data)
          console.log('fetchTicketStatuses - Ticket Statuses Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketTypes ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticketType')
        .then(res => {
          commit('setTicketTypes', res.data.data)
          console.log('fetcmhTicketTypes - Ticket Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketChannels ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticketChannel')
        .then(res => {
          commit('setTicketChannels', res.data.data)
          console.log('fetchTicketChannels - Ticket Channels Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchChannels ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/channel')
        .then(res => {
          commit('setChannels', res.data.data)
          console.log('fetchChannels - Channels Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchLabels ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/label')
        .then(res => {
          commit('setLabels', res.data.data)
          console.log('fetchLabels - Ticket Labels Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchLabelTypes ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/labelType')
        .then(res => {
          commit('setLabelTypes', res.data.data)
          console.log('fetchLabelTypes - Label Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchUser ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/user')
        .then(res => {
          commit('setUser', res.data.data)
          console.log('fetchUser - User Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchCustomerByEmail ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/customer/searchByEmail?email='+payload)
        .then(res => {
          console.log('fetchCustomerByEmail - Customer Searched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  storeTicket ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/helpdesk/ticket', {
        company_channels_id: payload.company_channels_id,
        ticket_types_id: payload.ticket_types_id,
        customers_id: payload.customers_id,
        customerEmail: payload.customerEmail,
        customerTitle: payload.customerTitle,
        customerFirstName: payload.customerFirstName,
        customerLastName: payload.customerLastName,
        customerTelephone: payload.customerTelephone,
        orders_id: payload.orders_id,
        subject: payload.subject,

      })
        .then(res => {
          dispatch('fetchTickets')
          console.log('storeTicket - Ticket Saved.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchTicket ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/ticket/'+payload)
        .then(res => {
          commit('setTicket', res.data.data)
          console.log('fetchTicket - Tickets Details Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  storeSnooze ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/helpdesk/snooze', {
        tickets_id: payload.tickets_id,
        snoozeUntil: payload.snoozeUntil,
      })
        .then(res => {
          console.log('storeSnooze - Ticket Snoozed.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  cancelSnooze ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/helpdesk/snooze', {
        tickets_id: payload,
        delete: 1,
      })
        .then(res => {
          console.log('cancelSnooze - Deleted Ticket Snoozes.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateStatus ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/helpdesk/ticket/'+payload.tickets_id, {
        tickets_status_id: payload.tickets_status_id,
      })
        .then(res => {
          console.log('updateStatus - Ticket Status Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateSpam ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/helpdesk/ticket/'+payload.tickets_id, {
        spam: payload.spam,
      })
        .then(res => {
          console.log('updateSpam - Ticket Spam Status Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateDeleted ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        deleted: payload.deleted,
      })
        .then(res => {
          console.log('updateDeleted - Ticket Deleted Status Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateFollowUp ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        followUp: payload.followUp,
      })
        .then(res => {
          console.log('updateFollowUp - Ticket Follow Up Status Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updatePriority ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        urgent: payload.urgent,
      })
        .then(res => {
          console.log('updatePriority - Ticket Priority Status Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateFavourite ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        favourite: payload.favourite,
      })
        .then(res => {
          console.log('updateBookmark - Ticket Bookmark Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateTicketType ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        ticket_types_id: payload.ticket_types_id,
      })
        .then(res => {
          console.log('updateTicketType - Ticket Type Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchTicketReplyTypes ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/replyType?tickets_id='+payload)
        .then(res => {
          console.log('fetchTicketStatuses - Ticket Reply Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  sendEmailReply ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.post('/api/helpdesk/reply', {
        tickets_id: payload.tickets_id,
        replyType: payload.replyType,
        scheduleDate: payload.scheduleDate,
        replyCCEmailArray: payload.replyCCEmailArray,
        replyBCCEmailArray: payload.replyBCCEmailArray,
        body: payload.body,
        newStatus: payload.newStatus,
        attachments: payload.attachments,
      })
        .then(res => {
          console.log('sendEmailReply - Email Reply Stored.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  sendExternalEmailReply ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.post('/api/helpdesk/reply', {
        tickets_id: payload.tickets_id,
        replyType: payload.replyType,
        scheduleDate: payload.scheduleDate,
        replyToEmailArray: payload.replyToEmailArray,
        replyCCEmailArray: payload.replyCCEmailArray,
        replyBCCEmailArray: payload.replyBCCEmailArray,
        body: payload.body,
        newStatus: payload.newStatus,
        attachments: payload.attachments,
      })
        .then(res => {
          console.log('sendExternalEmailReply - External Email Reply Stored.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  storeTicketNote ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.post('/api/helpdesk/note', {
        tickets_id: payload.tickets_id,
        notes: payload.body,
        attachments: payload.attachments,
      })
        .then(res => {
          console.log('storeTicketNote - Ticket Note Stored.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchTicketMessages ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/message?tickets_id='+payload)
        .then(res => {
          console.log('fetchTicketMessages - Ticket Messages Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTicketReplies ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/reply?tickets_id='+payload)
        .then(res => {
          console.log('fetchTicketReplies - Ticket Replies Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  updateAssignedUser ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        userID: payload.userID,
      })
        .then(res => {
          console.log('updateAssignedUser - User Association Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateAssignedTeam ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        teamID: payload.teamID,
      })
        .then(res => {
          console.log('updateAssignedTeam - Team Association Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateAssignedLabel ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/ticket/' + payload.tickets_id, {
        label: payload.labelID,
      })
        .then(res => {
          console.log('updateAssignedLabel - Label Association Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateReplyScheduleDate ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.put('/api/helpdesk/reply/' + payload.replyID, {
        replyID: payload.replyID,
        scheduleDate: payload.scheduleDate,
      })
        .then(res => {
          console.log('updateReplyScheduleDate - Schedule Date Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  deleteTicketReply ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.delete('/api/helpdesk/reply/' + payload.replyID, {
        replyID: payload.replyID,
      })
        .then(res => {
          console.log('deleteTicketReply - Ticket Reply Deleted.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  fetchSnippetTypes ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/snippetType')
        .then(res => {
          commit('setSnippetTypes', res.data.data)
          console.log('fetchSnippetTypes - Snippet Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchSnippetCategories ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/snippetCategory')
        .then(res => {
          commit('setSnippetCategories', res.data.data)
          console.log('fetchSnippetCategories - Snippet Categories Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchSnippets ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/snippet?tickets_id='+payload)
        .then(res => {
          commit('setSnippets', res.data.data)
          console.log('fetchSnippets - Snippets Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTemplateTypes ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/templateType')
        .then(res => {
          commit('setTemplateTypes', res.data.data)
          console.log('fetchTemplateTypes - Template Types Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchTemplates ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/helpdesk/template?tickets_id='+payload)
        .then(res => {
          commit('setTemplates', res.data.data)
          console.log('fetchTemplates - Templates Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  storeTicketReaders ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random() * hostnames.length)]
      axios.post('/api/helpdesk/reader', {
        tickets_id: payload,
      })
        .then(res => {
          console.log('storeTicketReaders - Ticket Readers Stored.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },


  // deleteTeam ({commit, dispatch}, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.delete('/api/company/team/'+payload)
  //       .then(res => {
  //         dispatch('fetchTeams')
  //         console.log('deleteTeam - Team Deleted.');
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },
  //
  // toggleTeamUser ({commit, dispatch}, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post('/api/company/team/toggle', {
  //       userID: payload.userID,
  //       teamID: payload.teamID,
  //     })
  //       .then(res => {
  //         console.log('toggleTeamUser - User Toggled in Team.');
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         const issues = new Errors();
  //         issues.record(error.response);
  //         reject(error.response);
  //       })
  //   })
  // },

};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/helpdesk/ticket.js